import { Drawer } from "antd"

const DrawerWrapper = ({
    children = <></>,
    ...props
}) => {

    return (
        <Drawer
            closable={false}
            width={450}
            styles={{
                header: {
                    textAlign: 'center',
                    backgroundColor: '#000',
                    color: '#fff'
                },
                body: {
                    margin: '4em 1em'
                }
            }}
            { ...props } // for more changeable and changed attribute
        >
            { children }
        </Drawer>
    )
}

export default DrawerWrapper